import { render, staticRenderFns } from "./form-component-contactdetails.vue?vue&type=template&id=3b722d3c&scoped=true"
import script from "./form-component-contactdetails.vue?vue&type=script&lang=ts"
export * from "./form-component-contactdetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b722d3c",
  null
  
)

export default component.exports